module.exports = __webpack_public_path__ + "static/media/template2.dbda3b3d.svg";